import {
    Content,
    TextContainer,
    Title,
    SubTitle,
    Description,
    StoreBadge,
    CarouselContainer,
    FilmSection,
    FilmTitle,
    FilmCaption,
    FilmVideo,
} from './styles';
import { appStoreURL } from '../../constants/urls';
import Carousel, { hasScreenshots } from '../Carousel';

const Home = () => {
    return (
        <>
        <Content $single={!hasScreenshots}>
            <TextContainer>
                <Title>AprèsStory</Title>
                <SubTitle>The route, the numbers, and the photographs you took on the way.</SubTitle>
                <Description>AprèsStory reads your runs, rides, hikes and days on snow out of Apple Health, finds the photographs you took during them, and plays each one back as a story — the route developing in safelight amber, the numbers climbing with it, your photographs in full colour. Send one to a person and they can watch it in a browser, without the app. No account, no analytics, no subscription.</Description>
                <a href={appStoreURL}><StoreBadge src="assets/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" /></a>
            </TextContainer>
            {hasScreenshots && (
                <CarouselContainer>
                    <Carousel />
                </CarouselContainer>
            )}
        </Content>

        {/* preload="none" on purpose: this is a 69-second film and most visitors will never
            press play. The poster is a still from it, so the section is not a black rectangle
            until they do. */}
        <FilmSection>
            <FilmTitle>See it end to end</FilmTitle>
            <FilmCaption>A little over a minute, from a month of activities to a story landing on somebody else's phone.</FilmCaption>
            <FilmVideo
                controls
                preload="none"
                playsInline
                poster="assets/film-poster.jpg"
            >
                <source src="assets/apresstory-film.mp4" type="video/mp4" />
                Your browser cannot play this video.
            </FilmVideo>
        </FilmSection>
        </>
    );
}

export default Home;
